export const DEFAULT_ERROR_MESSAGE =
  "Impossible de terminer cette action. Réessayez dans un instant.";
export const PHONE_REGEX =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
